import { useCallback, useMemo } from 'react'
import styles from './InputNumber.module.scss'

export const InputNumber = ({
	hideNumberArrows,
	onChange,
	type,
	min,
	max,
	classes = '',
	value,
	enablecheckfloat = false,
	integerOnly = false,
	...props
}) => {
	const onChangeValue = useCallback(
		(event) => {
			let value = event.target.value
			if ((type === 'number' && enablecheckfloat) || min != null || max != null) {
				value = value
					.replace(',', '.')
					.replace(/[^\d\.]/g, '')
					.replace(/\./, 'x')
					.replace(/\./g, '')
					.replace(/x/, '.')

				if (value.startsWith('.')) {
					const arr = value.split()
					value = ['0', ...arr].join('')
				}
				if (value[0] == 0 && value[1] == 0) {
					value = '0'
				}
				if (value[0] == 0 && value[1] && value[1] != '.') {
					const arr = value.split('')
					arr.splice(0, 1)
					value = ['0', '.', ...arr].join('')
				}

				// Если только целые, применить фильтр
				if (integerOnly) {
					value = value.replace(/[^\d]/g, '')
				}

				// Проверки мин/макс
				const formattedValue = Number(value)
				if (min != null && formattedValue < min) {
					value = min
				}
				if (max != null && formattedValue > max) {
					value = max
				}
			}

			const newEvent = {
				target: {
					name: event.target.name,
					value: value,
				},
			}

			onChange(newEvent)
		},
		[max, min, onChange, type, integerOnly]
	)

	let inputType = ''

	if (!enablecheckfloat) {
		inputType = type
	} else {
		inputType = type === 'number' ? undefined : type
	}

	const isForSelect = useMemo(() => type === 'select', [type])
	return (
		<input
			className={`${styles.input} ${hideNumberArrows ? styles.hideNumberArrows : ''} ${
				isForSelect ? styles.select : ''
			} ${classes}`}
			type={inputType}
			onChange={onChangeValue}
			value={value ?? ''}
			{...props}
		/>
	)
}
